import { render, staticRenderFns } from "./LabricotWastePrefillOption.vue?vue&type=template&id=ea6c6b56&"
import script from "./LabricotWastePrefillOption.vue?vue&type=script&lang=js&"
export * from "./LabricotWastePrefillOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports